import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { toast } from 'react-toastify';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import { SiteConstructor, SiteSupervisor } from 'app/edozvola/cases/construction-participants/model/construction-participants.model';
import {
  copySiteConstructors,
  copySiteSupervisors,
  deleteSiteConstructor,
  deleteSiteSupervisor,
  fetchSiteConstructor,
  fetchSiteConstructors,
  fetchSiteSupervisor,
  fetchSiteSupervisors,
  saveSiteConstructor,
  saveSiteSupervisor,
} from 'app/edozvola/cases/construction-participants/service/construction-participants.service';
import success = toast.success;
import error = toast.error;
import {messages, TABLE_QUERY_KEYS} from "app/config/constants";

export const saveSiteConstructorQuery = (idCase: string, onSuccessCallback) => {
  return useMutation({
    mutationFn: (siteConstructor: SiteConstructor) => {
      return saveSiteConstructor(idCase, siteConstructor);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.SITE_CONSTRUCTORS_TABLE] });
      onSuccessCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const fetchSiteConstructorsQuery = (pagination: PaginationState, idCase: string) => {
  return useQuery({
    queryKey: [TABLE_QUERY_KEYS.SITE_CONSTRUCTORS_TABLE, { idCase: idCase, pagination: { ...pagination } }],
    queryFn: ({ signal }) => fetchSiteConstructors(idCase, pagination.page, pagination.size, pagination.column, pagination.direction),
  });
};

export const fetchSiteConstructorQuery = (idSiteConstructor: string) => {
  return useQuery({
    queryKey: ['site-constructor', idSiteConstructor],
    queryFn: () => fetchSiteConstructor(idSiteConstructor),
    enabled: !!idSiteConstructor,
  });
};

export const deleteSiteConstructorQuery = () => {
  return useMutation({
    mutationFn: (idSiteConstructor: number) => deleteSiteConstructor(idSiteConstructor),
    onSuccess: () => {
      showToast(success, messages.DATA_DELETED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.SITE_CONSTRUCTORS_TABLE] });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const copySiteConstructorsFromCaseQuery = (caseUuid: string, onSuccessCallback: any) => {
  return useMutation({
    mutationFn: (caseUuidToCopyFrom: string) => copySiteConstructors(caseUuid, caseUuidToCopyFrom),
    onSuccess: () => {
      onSuccessCallback();
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.SITE_CONSTRUCTORS_TABLE] });
      showToast(success, messages.DATA_COPIED);
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const fetchSiteSupervisorQuery = (idCase: string, idSiteSupervisor: string) => {
  return useQuery({
    queryKey: ['site-supervisor', idSiteSupervisor],
    queryFn: () => fetchSiteSupervisor(idCase, idSiteSupervisor),
    enabled: !!idSiteSupervisor,
  });
};

export const fetchSiteSupervisorsQuery = (pagination: PaginationState, idCase: string) => {
  return useQuery({
    queryKey: [TABLE_QUERY_KEYS.SITE_SUPERVISORS_TABLE, { idCase: idCase, pagination: { ...pagination } }],
    queryFn: ({ signal }) => fetchSiteSupervisors(idCase, pagination.page, pagination.size, pagination.column, pagination.direction),
  });
};

export const saveSiteSupervisorQuery = (idCase: string, onSuccessCallback) => {
  return useMutation({
    mutationFn: (siteSupervisor: SiteSupervisor) => {
      return saveSiteSupervisor(idCase, siteSupervisor);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.SITE_SUPERVISORS_TABLE] });
      onSuccessCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const deleteSiteSupervisorQuery = (idCase: string) => {
  return useMutation({
    mutationFn: (idSiteSupervisor: number) => deleteSiteSupervisor(idCase, idSiteSupervisor),
    onSuccess: () => {
      showToast(success, messages.DATA_DELETED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.SITE_SUPERVISORS_TABLE] });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const copySiteSupervisorsFromCaseQuery = (caseUuid: string, onSuccessCallback: any) => {
  return useMutation({
    mutationFn: (caseUuidToCopyFrom: string) => copySiteSupervisors(caseUuid, caseUuidToCopyFrom),
    onSuccess: () => {
      onSuccessCallback();
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.SITE_SUPERVISORS_TABLE] });
      showToast(success, messages.DATA_COPIED);
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
